// src/api/clients.ts
import api from "./api";

export interface Client {
  id: string;
  clientName: string;
  email: string | null;
  phone: string | null;
  address1: string | null;
  address2: string | null;
  state: string | null;
  country: string | null;
  pincode: string | null;
  gstin: string | null;
  pan: string | null;
  user_id: string;
  branchID: string | null;
}

export interface ClientCreatePayload {
  clientName: string;
  email?: string;
  phone?: string;
  address1?: string;
  address2?: string;
  state?: string;
  country?: string;
  pincode?: string;
  gstin?: string;
  pan?: string;
}

export interface ClientUpdatePayload {
  clientName?: string;
  email?: string;
  phone?: string;
  address1?: string;
  address2?: string;
  state?: string;
  country?: string;
  pincode?: string;
  gstin?: string;
  pan?: string;
}

export const clientsApi = {
  list: (params?: { search?: string; page?: number; page_size?: number }) =>
    api.get("/clients", { params }),

  get: (clientId: string) =>
    api.get(`/clients/${clientId}`),

  create: (payload: ClientCreatePayload) =>
    api.post("/clients", payload),

  update: (clientId: string, payload: ClientUpdatePayload) =>
    api.patch(`/clients/${clientId}`, payload),

  delete: (clientId: string) =>
    api.delete(`/clients/${clientId}`),

  settings: () =>
    api.get('/get_startup_khata'),

  importClients: (payload: any[]) =>
    api.post('/clients/import_clients', payload),

  importExcel: (formData: FormData) =>
    api.post("/clients/import_client_excel", formData),
};
